module.exports = __webpack_public_path__ + "img/landing-demo-video.5ac874f8.svg";